import axios from './api';

export default function changeProfileImage(params) {
    const request = {
        profileImage: params.profileImage,
        gender: params.gender,
        transactionPassword: params.transactionPassword,
        password: params.password,
    }

    return new Promise((resolve, reject) => {
        axios.post("app/updateUserInfo", request, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
